/**
 *
 * ================ THIS FILE IS GENERATED ===============
 *
 * No changes should be made directly in this file - your change will be reflected
 * here after you make your changes directly in the source files and run
 * npm run locale:generate <folder>
 *
 * Documentation here:
 *
 */

// eslint-disable-next-line @typescript-eslint/no-var-requires
const tx = require("@transifex/native");

module.exports = {
    brand: {
        admin: {
            products: {
                title: tx.t("Product catalog settings", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Product Catalog Settings submenu",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.title",
                }),
                barcode_management_label: tx.t("Barcode management", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Barcode Management configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.barcode_management_label",
                }),
                barcode_management_desc: tx.t("Manage your barcode settings.", {
                    _context:
                        "Brand admin Products menu - subsection desciption - redirects to Barcode Management configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.barcode_management_desc",
                }),
                barcode_printing_label: tx.t("Barcode printing", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Barcode Printing configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.barcode_printing_label",
                }),
                barcode_printing_desc: tx.t("Print your barcodes.", {
                    _context:
                        "Brand admin Products menu - subsection desciption - redirects to Barcode Printing configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.barcode_printing_desc",
                }),
                manage_catalogs_label: tx.t("Manage catalogs", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.manage_catalogs_label",
                }),
                manage_linesheets_label: tx.t("Manage linesheets", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.manage_linesheets_label",
                }),
                manage_linesheets_desc: tx.t("Create and edit custom templates.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Linesheet/Catalogs configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.manage_linesheets_desc",
                }),
                product_banners_label: tx.t("Product banners", {
                    _context:
                        "Brand admin Products menu - subsection label - redirects to Product Banners configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.product_banners_label",
                }),
                product_banners_desc: tx.t("Create and manage banners for products.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Banners configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.product_banners_desc",
                }),
                product_gallery_label: tx.t("Product gallery", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Gallery configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.product_gallery_label",
                }),
                product_gallery_desc: tx.t("Edit, merchandise and enable products.", {
                    _context:
                        "Brand admin Products menu - subsection description - redirects to Product Gallery configuration and settings",
                    _tags: "brand,admin,products",
                    _key: "brand.admin.products.product_gallery_desc",
                }),
            },
            data: {
                title: tx.t("Data", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Data submenu",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.title",
                }),
                company_data_label: tx.t("Company data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Company Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.company_data_label",
                }),
                company_data_desc: tx.t("Upload and download company data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Company Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.company_data_desc",
                }),
                buyer_data_label: tx.t("Buyer data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Buyer Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.buyer_data_label",
                }),
                buyer_data_desc: tx.t("Upload and download buyer data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Buyer Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.buyer_data_desc",
                }),
                inventory_data_label: tx.t("Inventory data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Inventory Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.inventory_data_label",
                }),
                inventory_data_desc: tx.t("Upload and download inventory data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Inventory Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.inventory_data_desc",
                }),
                product_data_label: tx.t("Product data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Product Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.product_data_label",
                }),
                product_data_desc: tx.t("Upload and download product data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Product Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.product_data_desc",
                }),
                size_pack_data_label: tx.t("Size pack data", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Size Pack Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.size_pack_data_label",
                }),
                size_pack_data_desc: tx.t("Upload and download size pack data.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Size Pack Data configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.size_pack_data_desc",
                }),
                pricing_label: tx.t("Pricing", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Pricing configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.pricing_label",
                }),
                pricing_desc: tx.t("Upload and download price sheets.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Pricing configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.pricing_desc",
                }),
                archives_label: tx.t("Archives", {
                    _context:
                        "Brand admin Data menu - subsection label - redirects to Archives configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.archives_label",
                }),
                archives_desc: tx.t("Archive and unarchive products, orders and companies.", {
                    _context:
                        "Brand admin Data menu - subsection description - redirects to Archives configuration and settings",
                    _tags: "brand,admin,data",
                    _key: "brand.admin.data.archives_desc",
                }),
            },
            settings: {
                title: tx.t("Settings", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Settings submenu",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.title",
                }),
                manage_data_sync_label: tx.t("Manage data sync", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Data Sync configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.manage_data_sync_label",
                }),
                manage_data_sync_desc: tx.t(
                    "Sync product data and view connection status and dates across all of your mapped retailers.",
                    {
                        _context:
                            "Brand admin Settings menu - subsection description - redirects to Manage Data Sync configuration and settings",
                        _tags: "brand,admin,settings",
                        _key: "brand.admin.settings.manage_data_sync_desc",
                    }
                ),
                brand_settings_label: tx.t("Brand settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Brand Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.brand_settings_label",
                }),
                brand_settings_desc: tx.t("Manage contact info, weekly digest email list and subteams.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Brand Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.brand_settings_desc",
                }),
                branded_login_label: tx.t("Branded login", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Brand Login configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.branded_login_label",
                }),
                branded_login_desc: tx.t("Enter branded login info for this brand.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Brand Login configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.branded_login_desc",
                }),
                api_management_label: tx.t("API management", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to API Management configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.api_management_label",
                }),
                api_management_desc: tx.t("Retrieve API keys and approve or disable application tokens.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to API Management configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.api_management_desc",
                }),
                delivery_windows_label: tx.t("Delivery windows", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Delivery Windows configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.delivery_windows_label",
                }),
                delivery_windows_desc: tx.t("Set defined delivery windows.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Delivery Windows configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.delivery_windows_desc",
                }),
                user_groups_label: tx.t("Customer and user groups", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Customer & User groups configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.user_groups_label",
                }),
                user_groups_desc: tx.t("Manage your groups and product visibility rules.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Customer & User groups configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.user_groups_desc",
                }),
                payment_processing_label: tx.t("Manage payment processing", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Payment Processing configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.payment_processing_label",
                }),
                payment_processing_desc: tx.t("Manage payment processing accounts.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Payment Processing configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.payment_processing_desc",
                }),
                inventory_settings_label: tx.t("Inventory settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Inventory Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.inventory_settings_label",
                }),
                inventory_settings_desc: tx.t("Set preferences and thresholds and manage warehouses.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Inventory Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.inventory_settings_desc",
                }),
                order_rules_label: tx.t("Order min max rules", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Rules configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_rules_label",
                }),
                order_rules_desc: tx.t("Set rules for minimum or maximum values on orders.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Rules configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_rules_desc",
                }),
                order_settings_label: tx.t("Order settings", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_settings_label",
                }),
                order_settings_desc: tx.t("Set order preferences, splitting rules and Terms and Conditions.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Settings configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_settings_desc",
                }),
                custom_templates_label: tx.t("Order export templates", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Export Templates configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.custom_templates_label",
                }),
                custom_templates_desc: tx.t("Create and edit templates for order exports.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Export Templates configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.custom_templates_desc",
                }),
                order_export_info_label: tx.t("Order export information", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Order Export Info configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_export_info_label",
                }),
                order_export_info_desc: tx.t("Create or edit the order export CSV file.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Order Export Info configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.order_export_info_desc",
                }),
                ats_reports_label: tx.t("ATS report templates", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to ATS Report Templates configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.ats_reports_label",
                }),
                ats_reports_desc: tx.t("Create and edit ATS templates.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to ATS Report Templates configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.ats_reports_desc",
                }),
                payment_history_label: tx.t("Payment history", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Payment History configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.payment_history_label",
                }),
                payment_history_desc: tx.t("Export order payment history.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Payment History configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.payment_history_desc",
                }),
                stitchlabs_integration_label: tx.t("Stitch Labs integration", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to StitchLabs Integration configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.stitchlabs_integration_label",
                }),
                stitchlabs_integration_desc: tx.t("Set up an integration with the Stitch Labs ERP.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to StitchLabs Integration configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.stitchlabs_integration_desc",
                }),
                matterport_integration_label: tx.t("Matterport integration", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Matterport Integration configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.matterport_integration_label",
                }),
                matterport_integration_desc: tx.t(
                    "Set up an integration with Matterport for the 3D walk through in Sites Manager.",
                    {
                        _context:
                            "Brand admin Settings menu - subsection description - redirects to Matterport Integration configuration and settings",
                        _tags: "brand,admin,settings",
                        _key: "brand.admin.settings.matterport_integration_desc",
                    }
                ),
                marketplace_profile_label: tx.t("Manage Marketplace profile", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Marketplace Profile configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_profile_label",
                }),
                marketplace_profile_desc: tx.t("Manage brand profile in the Marketplace.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Marketplace Profile configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.marketplace_profile_desc",
                }),
                online_trade_show_label: tx.t("Guest buyer visibility", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Guest Buyer Visibility configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.online_trade_show_label",
                }),
                online_trade_show_desc: tx.t("Set up product visibility for guest buyers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Guest Buyer Visibility configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.online_trade_show_desc",
                }),
                shipping_management_label: tx.t("Manage shipping", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Shipping configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.shipping_management_label",
                }),
                shipping_management_desc: tx.t("Connect your warehouses to different shipping carriers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Shipping configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.shipping_management_desc",
                }),
                manage_shipping_promotions_label: tx.t("Manage shipping promotions", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Shipping Promotions configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.manage_shipping_promotions_label",
                }),
                manage_shipping_promotions_desc: tx.t("Create and edit shipping promotions.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Shipping Promotions configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.manage_shipping_promotions_desc",
                }),
                manage_sizes_label: tx.t("Manage sizes", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Manage Sizes configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.manage_sizes_label",
                }),
                manage_sizes_desc: tx.t("Manage product sizes.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Manage Sizes configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.manage_sizes_desc",
                }),
                terms_and_conditions_label: tx.t("Usage Terms and Conditions", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to T&C configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.terms_and_conditions_label",
                }),
                terms_and_conditions_desc: tx.t("Manage Terms and Conditions for buyers.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to T&C configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.terms_and_conditions_desc",
                }),
                pricing_label: tx.t("Pricing", {
                    _context:
                        "Brand admin Settings menu - subsection label - redirects to Pricing configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.pricing_label",
                }),
                pricing_desc: tx.t("Manage pricing configurations.", {
                    _context:
                        "Brand admin Settings menu - subsection description - redirects to Pricing configuration and settings",
                    _tags: "brand,admin,settings",
                    _key: "brand.admin.settings.pricing_desc",
                }),
            },
            users: {
                title: tx.t("Users", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Users submenu",
                    _tags: "brand,admin,users",
                    _key: "brand.admin.users.title",
                }),
                brand_users_label: tx.t("Manage brand users", {
                    _context:
                        "Brand admin Users menu - subsection label - redirects to Manage Brand Users configuration and settings",
                    _tags: "brand,admin,users",
                    _key: "brand.admin.users.brand_users_label",
                }),
                brand_users_desc: tx.t("Create, edit and delete brand users.", {
                    _context:
                        "Brand admin Users menu - subsection description - redirects to Manage Brand Users configuration and settings",
                    _tags: "brand,admin,users",
                    _key: "brand.admin.users.brand_users_desc",
                }),
                product_visibility_report_label: tx.t("Product visibility report", {
                    _context:
                        "Brand admin Users menu - subsection label - redirects to Product Visibility Report configuration and settings",
                    _tags: "brand,admin,users",
                    _key: "brand.admin.users.product_visibility_report_label",
                }),
                product_visibility_report_desc: tx.t("Diagnose product visibility issues by user.", {
                    _context:
                        "Brand admin Users menu - subsection description - redirects to Product Visibility Report configuration and settings",
                    _tags: "brand,admin,users",
                    _key: "brand.admin.users.product_visibility_report_desc",
                }),
            },
            promotions: {
                title: tx.t("Promotions", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Promotions submenu",
                    _tags: "brand,admin,promotions",
                    _key: "brand.admin.promotions.title",
                }),
                manage_promotions_label: tx.t("Manage Promotions", {
                    _context:
                        "Brand admin Promotions menu - subsection label - redirects to Promotions configuration and settings",
                    _tags: "brand,admin,promotions",
                    _key: "brand.admin.promotions.manage_promotions_label",
                }),
                manage_promotions_desc: tx.t("Create, edit and deactivate Promotions.", {
                    _context:
                        "Brand admin Promotions menu - subsection description - redirects to Promotions configuration and settings",
                    _tags: "brand,admin,promotions",
                    _key: "brand.admin.promotions.manage_promotions_desc",
                }),
            },
            imagery: {
                title: tx.t("Imagery & media", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Imagery & Media submenu",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.title",
                }),
                dropbox_management_label: tx.t("Dropbox management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Dropbox Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.dropbox_management_label",
                }),
                dropbox_management_unlimited_images_desc: tx.t(
                    "Import your product images and videos directly from Dropbox.",
                    {
                        _context:
                            "Brand admin Imagery & Media menu - subsection description - redirects to Dropbox Management configuration and settings",
                        _tags: "brand,admin,imagery",
                        _key: "brand.admin.imagery.dropbox_management_unlimited_images_desc",
                    }
                ),
                dropbox_management_desc: tx.t("Import your product images directly from Dropbox.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Dropbox Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.dropbox_management_desc",
                }),
                image_management_label: tx.t("Image management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_management_label",
                }),
                image_management_desc: tx.t("Assign images to products.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_management_desc",
                }),
                email_image_management_label: tx.t("Email header image management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Email Header Image Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.email_image_management_label",
                }),
                email_image_management_desc: tx.t("Upload custom email header image.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Email Header Image Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.email_image_management_desc",
                }),
                image_reports_label: tx.t("Image reports", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Reports configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_reports_label",
                }),
                image_reports_desc: tx.t("Download image reports.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Reports configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_reports_desc",
                }),
                image_settings_label: tx.t("Image settings", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Image Settings configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_label",
                }),
                image_settings_desc: tx.t("Set up and manage image and media naming convention.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Settings configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_desc",
                }),
                image_settings_unlimited_images_desc: tx.t("Set up and manage image and media naming conventions.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Image Settings configuration and settings for brand with unlimited_images brand preference",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.image_settings_unlimited_images_desc",
                }),
                product_images_label: tx.t("Product images", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Product Images configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.product_images_label",
                }),
                product_images_desc: tx.t("Upload product images.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Product Images configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.product_images_desc",
                }),
                media_management_label: tx.t("Media management", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Media Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.media_management_label",
                }),
                media_management_desc: tx.t("Manage image galleries, press and video assets.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Media Management configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.media_management_desc",
                }),
                color_swatches_label: tx.t("Color swatches", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Color Swatches configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.color_swatches_label",
                }),
                color_swatches_desc: tx.t("Upload swatches, pick colors and assign to products.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Color Swatches configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.color_swatches_desc",
                }),
                logos_management_label: tx.t("Custom branding", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Custom Branding configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.logos_management_label",
                }),
                logos_management_desc: tx.t("Manage your in-app branding.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Custom Branding configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.logos_management_desc",
                }),
                watermarking_label: tx.t("Watermarking", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection label - redirects to Watermarking configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.watermarking_label",
                }),
                watermarking_desc: tx.t("Manage settings for watermarking of product images.", {
                    _context:
                        "Brand admin Imagery & Media menu - subsection description - redirects to Watermarking configuration and settings",
                    _tags: "brand,admin,imagery",
                    _key: "brand.admin.imagery.watermarking_desc",
                }),
            },
            payment: {
                title: tx.t("Payment", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Payment submenu",
                    _tags: "brand,admin,payment",
                    _key: "brand.admin.payment.title",
                }),
                payment_preferences_label: tx.t("Payment preferences", {
                    _context:
                        "Brand admin Payment menu - subsection label - redirects to Payment Preferences configuration and settings",
                    _tags: "brand,admin,payment",
                    _key: "brand.admin.payment.payment_preferences_label",
                }),
                payment_preferences_desc: tx.t("Configure preferences for payment methods.", {
                    _context:
                        "Brand admin Payment menu - subsection description - redirects to Payment Preferences configuration and settings",
                    _tags: "brand,admin,payment",
                    _key: "brand.admin.payment.payment_preferences_desc",
                }),
                payment_configurations_label: tx.t("Payment configurations", {
                    _context:
                        "Brand admin Payment menu - subsection label - redirects to Payment Configurations configuration and settings",
                    _tags: "brand,admin,payment",
                    _key: "brand.admin.payment.payment_configurations_label",
                }),
                payment_configurations_desc: tx.t("Centralized payment configurations for easy payment setup.", {
                    _context:
                        "Brand admin Payment menu - subsection description - redirects to Payment Configurations configuration and settings",
                    _tags: "brand,admin,payment",
                    _key: "brand.admin.payment.payment_configurations_desc",
                }),
            },
            customizations: {
                title: tx.t("Customizations", {
                    _context: "Brand admin menu - Subsection title - Admin page menu Customizations submenu",
                    _tags: "brand,admin,customizations",
                    _key: "brand.admin.customizations.title",
                }),
                manage_logo_label: tx.t("Manage logo", {
                    _context:
                        "Brand admin Customizations menu - subsection label - redirects to Manage Logo configuration and settings",
                    _tags: "brand,admin,customizations",
                    _key: "brand.admin.customizations.manage_logo_label",
                }),
                manage_logo_desc: tx.t("Manage uploaded logos for customizable products.", {
                    _context:
                        "Brand admin Customizations menu - subsection desciption - redirects to Manage Logo configuration and settings",
                    _tags: "brand,admin,customizations",
                    _key: "brand.admin.customizations.manage_logo_desc",
                }),
            },
            title: tx.t("Admin", {
                _context: "Brand admin menu - page title - Admin page title",
                _tags: "brand,admin",
                _key: "brand.admin.title",
            }),
            brand_admin_title: tx.t("Brand Admin", {
                _context: "Brand admin menu - Menu title - Admin page menu title breadcrumb",
                _tags: "brand,admin",
                _key: "brand.admin.brand_admin_title",
            }),
        },
    },
};
